import gql from 'graphql-tag';

export default gql`
  query mySummaryQuery {
    viewer {
      id
      loyaltyId
      firstName
      lastName
      loyalty {
        status
        total
        pointsValue
      }
      isLoyaltyCardLinked
    }
  }
`;
